export const julyAbbreviatedLowercase = "eqa";
export default {julyAbbreviatedLowercase};